
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DomainRenewalInfoModel extends Model<DomainRenewalInfoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'awaitingProvider', type: 'boolean', languageString: 'domainRenewalInfo.property.awaitingProvider' },
		{ name: 'expireDate', type: 'Date', languageString: 'domainRenewalInfo.property.expireDate' },
		{ name: 'renewalPeriodMonths', type: 'number', languageString: 'domainRenewalInfo.property.renewalPeriodMonths' },
		{ name: 'registrantValidated', type: 'boolean', languageString: 'domainRenewalInfo.property.registrantValidated' },
		{ name: 'registrarManaged', type: 'boolean', languageString: 'domainRenewalInfo.property.registrarManaged' },
		{ name: 'registrarAction', type: 'string', languageString: 'domainRenewalInfo.property.registrarAction' },
		{ name: 'registrarActionCompleted', type: 'boolean', languageString: 'domainRenewalInfo.property.registrarActionCompleted' }
	];
	[key: string]: any;
	
	public awaitingProvider: boolean;
	public expireDate?: Date;
	public renewalPeriodMonths?: number;
	public registrantValidated?: boolean;
	public registrarManaged: boolean;
	public registrarAction: string;
	public registrarActionCompleted: boolean;
    
	constructor(){
		super();
		this.awaitingProvider = false;
		this.expireDate = undefined;
		this.renewalPeriodMonths = undefined;
		this.registrantValidated = undefined;
		this.registrarManaged = false;
		this.registrarAction = '';
		this.registrarActionCompleted = false;
		
	}
	getProperties(){
		return DomainRenewalInfoModel.classProperties;
	}
}

